import { gql } from "@apollo/client";

export const userPhoneVerifyQuery = gql`
  query {
    user {
      phone
      phone_verified
    }
  }
`;
